import { render, staticRenderFns } from "./CNPJ.vue?vue&type=template&id=02460422&"
import script from "./CNPJ.vue?vue&type=script&lang=js&"
export * from "./CNPJ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports